
import getters from './getters'
import callbacks from './callbacks'
import { objMap } from './values'

const filterMap = {}
for (const name in callbacks) {
  filterMap[name] = {
    callback: callbacks[name],
    values: []
  }
}

const updateFilterMap = state => {
  for (const name in state) {
    if (filterMap[name]) {
      filterMap[name].values = state[name].values
    }
  }
}

const getItemValues = (name, item) => {
  // TODO -> validate object values ....?! -> will also be done in setValue
  if (typeof objMap[name] === 'function') return objMap[name](item)
  return []
}

export default {

  resetFilter (context) {
    this.dispatch('results/setItems', Object.values(context.rootGetters['products/items']))
      .then(() => context.commit('resetValues'))
  },

  setValue (context, { name, title, value }) {
    const isSet = getters.isSet(context.state)
    if (!isSet(name, value) || context.state[name].values.length === 1) {
      context.commit('resetValues')
      context.commit('clearCallstack')
    }

    context.commit('setValue', { name, value })
    context.commit('pushCallstack', { name, title, value }) // should only be done on action setValue

    updateFilterMap(context.state)

    this.dispatch('results/filterProducts', filterMap)
      .then(() => context.dispatch('setFilterByResults'))
  },

  setFilterByResults (context) {
    const items = context.rootGetters['results/items']
    const values = {}
    for (const name in context.state) {
      if (context.state[name].values.length !== 1) { // for all implicit values
        if (!values[name]) values[name] = { name: name, value: [] }
        for (let i = 0; i < items.length; i++) {
          const newValues = getItemValues(name, items[i])
          for (let j = 0; j < newValues.length; j++) {
            if (values[name].value.indexOf(newValues[j]) < 0) values[name].value.push(newValues[j])
          }
        }
      }
    }

    // TODO -> do a more elegant way -> respect vdom update interval
    const valueList = Object.values(values)
    for (let i = 0; i < valueList.length; i++) {
      context.commit('setValue', { name: valueList[i].name, value: valueList[i].value })
    }
  }

}
